import "./Header.scss";
import { useRoute } from "wouter";
import { Navigation } from "./Navigation";
import { ReactComponent as Logo } from "./../../assets/images/latelier-logo.svg";
import { LinkTo } from "../LinkTo";
import { useState, useRef, useEffect, useCallback } from "react";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { LegalLinks } from "../LegalLinks";

export function Header() {
	const [matchBreakdown] = useRoute("/score-breakdown");
	const [radarProjectInfoMatch] = useRoute("/tech-radar/project-info");
	const [breakdownProjectInfoMatch] = useRoute("/score-breakdown/project-info");
	const [radarCategoryInfoMatch] = useRoute("/tech-radar/category/:slug");

	const [burgerOpen, setBurgerOpen] = useState(false);
	const mobileMenu = useRef();

	const handleBurgerOpen = () => {
		setBurgerOpen(!burgerOpen);
	};

	const handleLinkClick = () => {
		setBurgerOpen(false);
	};

	const handleResize = useCallback(() => {
		setBurgerOpen(false);
	}, []);

	useEffect(() => {
		if (burgerOpen) {
			disableBodyScroll(mobileMenu.current);
		} else {
			enableBodyScroll(mobileMenu.current);
		}
	}, [burgerOpen]);

	useEffect(() => {
		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, [handleResize]);

	return (
		<div
			className={`header ${
				breakdownProjectInfoMatch ||
				radarProjectInfoMatch ||
				radarCategoryInfoMatch
					? "header--modal-open"
					: ""
			}`}>
			<div className="header__inner">
				<div className="header__logo">
					<div className="header__logo__inner">
						<LinkTo href={"/"} onClick={handleLinkClick}>
							<Logo />
						</LinkTo>
						<div
							className={`header__logo__burger-icon ${
								burgerOpen ? "header__logo__burger-icon--open" : ""
							}`}>
							<button onClick={handleBurgerOpen}>
								<div></div>
								<div></div>
							</button>
						</div>
					</div>
				</div>
				<div
					className={`header__mobile-menu ${
						burgerOpen ? "header__mobile-menu--open" : ""
					}`}
					ref={mobileMenu}>
					<LinkTo
						href={
							matchBreakdown
								? "/score-breakdown/project-info"
								: "/tech-radar/project-info"
						}
						onClick={handleLinkClick}>
						<span>Project Info</span>
					</LinkTo>
					<LegalLinks onClick={handleLinkClick} />
				</div>
				<div className="header__navigation">
					<div className="header__navigation__inner">
						<Navigation onClick={handleLinkClick} />
					</div>
				</div>
				<div className="header__cta">
					<LinkTo
						href={
							matchBreakdown
								? "/score-breakdown/project-info"
								: "/tech-radar/project-info"
						}
						onClick={handleLinkClick}>
						Project Info
					</LinkTo>
				</div>
			</div>
		</div>
	);
}
